import gql from "graphql-tag";

export const paycheckFormFragment = gql`
  fragment paycheckFormFragment on Paycheck {
    id
    currencyCode

    logo {
      id
      signedBlobId
      url(size: LARGE)
    }

    employeeName
    employeeAddress
    employeeZip
    employeeCity
    employeeSocialSecurityNumber
    employeeTemporarySocialSecurityNumber
    taxTable
    taxPercentage
    taxExemption
    taxDeductionMethod
    taxExemptionAmountLimit
    employeeBban
    employeeIban
    employeeSwift
    number
    leaveAndLayoffs{
      id
      startDate
      endDate
      description
    }
    comment

    employerName
    employerAddress
    employerZip
    employerCity
    employerOrganizationNumber
    unit {
      id
      mobile
      email
    }
    companyMunicipality {
      id
      number
      name
      bban
      organizationNumber
      organizationName
      organizationForm
      comment
      webpage
      email
      telephone
      mobile
      telefax
      address1
      address2
      address3
      zip
      city
      countyName
      employerTaxZone {
        id
        rate
        code
      }
    }
    companyMunicipalityTaxRate

    period {
      id
      name
      startDate
      endDate
    }
    startDate
    endDate
    workRelationEndReason
    workRelationDurationType
    journalDate
    dueDate
    paidDate

    shiftType
    employmentType
    occupation {
      id
      name
      code
      validFrom
    }
    workRelation {
      id
      startDate
      subUnit {
        id
        name
      }
      employee {
        id
        creditDays
        vacationMoneyPercentage
      }
    }
    employmentPercentage
    internalComment
    vacationMoneyPercentage

    shouldSendToAltinn
    shouldSendToFakturabank
    advancedMode

    draftSavedAt
    draftSavedBy { id name }

    savedAt
    savedBy { id name }

    lockedAt
    lockedBy { id name }

    taxDeductionTooLowConfirmedAt
    taxDeductionTooLowConfirmedBy { id name }

    paidDateUpdatedAt
    paidDateUpdatedBy {
      id name
    }

    paycheckLines {
      id
      number
      description
      altinnDescription
      altinnFordel
      quantity
      rate
      sum
      car {
        id
        name
        registrationNumber
      }
      project {
        id
        code
        name
      }
      department {
        id
        code
        name
        unit {
          id
        }
      }
      carOverwrite
      projectOverwrite
      departmentOverwrite
      taxable
      employerTaxable
      includeInVacationMoneyBase
      taxDeduction
      taxDeductionVoluntary
      calculatePositive
      calculationType
      garnishment
      garnishmentSamordnet
      vacationMoneyEarnedInPreviousYear
      paycheckLineTemplate {
        id
      }
      altinnAdditional {
        carAndBoat {
          listPriceForCar
          carRegistrationNumber
        }
      }
    }
    ameldings {
      id
      humanStatus
      ameldingReference
      altinnSubmission {
        id
        sentAt
        sentBy { name }
        processedAt
      }
      altinn3Submission {
        id
        sentAt
        sentBy { name }
      }
      cancellation
      replacementAmelding {
        id
        ameldingReference
      }
      ameldingToReplace {
        id
        ameldingReference
      }
    }
    prepayments {
      id
      amount
      paymentDate
    }
  }
`;
